import React from "react";
import trans from "../../../../../utils";
import ObjectSelectedRows from "../ObjectSelectedRows";
import { formatDateString } from "../../../../../JsHelpers/DateFormat";

export default function SelectedDeviceAssign({ values, device }) {
	const lang = localStorage.getItem("lang") || "en";
	const deviceInfo = values?.device;

	return (
		<div>
			<div>
				<div className="object-body-title">
					<div className="fs-16 fw-600" role="button">
						{trans("Current Assignment")}
					</div>
				</div>

				<div className="object-selected-details">
					<ObjectSelectedRows
						title={trans("Assigned To")}
						item={deviceInfo?.currentUserName}
					/>
					<ObjectSelectedRows
						title={trans("Assignment Date")}
						item={
							deviceInfo?.currentAssignmentDate
								? formatDateString(deviceInfo.currentAssignmentDate)
								: "-"
						}
					/>
					<ObjectSelectedRows
						title={trans("Total Users")}
						item={deviceInfo?.totalUsers}
					/>
				</div>
			</div>
		</div>
	);
}